const CzechFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="10" fill="#FFFFFF"/>
    <rect y="10" width="30" height="10" fill="#D7141A"/>
    <polygon points="0,0 15,10 0,20" fill="#11457E"/>
  </svg>
);

export default CzechFlag;